<template>
  <div class="app-main-content">
    <div
      class="main-content"
      type="primary"
    >
      <air-search-bar
        :show-level="true"
        :show-currency="false"
        :filter="filter"
        :is-manage-module="true"
        config-id="priceAir"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
        @onGridRefresh="gridRefresh"
        @reset="resetGrid"
      >
        <template v-if="activeTabName === 'cpList'" slot="operations">
          <el-button v-show="inputAllowed_PP" no="onEdit" type="primary" :disabled="!this.cpSelectRow" @click="onEdit()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onDeleteCP" type="danger" @click="onDelete_CP()">{{ $t('Pricing.Delete') }}</el-button>
        </template>
        <template v-if="activeTabName !== 'cpList'" slot="operations">
          <el-button v-show="inputAllowed_PP" no="onEdit1" type="primary" :disabled="!this.ppSelectRow" @click="onEdit()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button no="onDeletePP" type="danger" :disabled="!selectedPpRows || selectedPpRows.length === 0" @click="onDelete_PP()">{{ $t('Pricing.Delete') }}</el-button>
          <el-button v-show="approveAllowed_PP" no="onApprovePP2" :disabled="!selectedPpRows || selectedPpRows.length === 0" type="primary" @click="onApprove_PP2()">{{ $t('Pricing.SchemeAudit') }}</el-button>
          <el-button v-show="approveAllowed_PP" no="onApprovePP" type="primary" :disabled="!selectedPpRows || selectedPpRows.length === 0" @click="onApprove_PP()">{{ $t('Pricing.ManualAudit') }}</el-button>
          <el-button v-show="approveAllowed_PP && filter.level === 0" no="onMarkupApprove" type="primary" :disabled="!selectedPpRows || selectedPpRows.length === 0" @click="onMarkupApprove()">{{ $t('Pricing.markupApprove') }}</el-button>
          <!-- <el-button v-show="isHQManager || checkPermission()" no="onConfigPriceAir" type="primary" :disabled="false" @click="onConfigPriceAir()">{{ $t('Pricing.Setting') }}</el-button> -->
          <el-button type="primary" :disabled="false" @click="schemeSettings()">{{ $t('Price.ProgramSettings') }}</el-button>
          <el-button v-show="inputAllowed_PP" no="onAddPP" type="primary" @click="onAdd_PP()">{{ $t('Pricing.Add') }}</el-button>
          <el-button v-show="inputAllowed_PP" no="onDownloadTemplate" type="primary" @click="onDownloadTemplate()">{{ $t('Pricing.Template') }}</el-button>
          <el-upload
            v-show="inputAllowed_PP"
            no="savePriceAirExcelFile"
            :action="URL.price.savePriceAirExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :on-success="uploadExcelSuccess"
            :data="{branchId: branchId}"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="import" type="primary">{{ $t('Pricing.Import') }}</el-button>
          </el-upload>
        </template>
      </air-search-bar>
    </div>
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="$t('Pricing.CurrentPrice')" name="cpList">
          <air-data-grid
            :v-if="activeTabName === 'cpList'"
            config-module="223101"
            :show-create="true"
            :show-modify="true"
            :show-approve="true"
            :show-selection="true"
            :show-agent="false"
            :row-data="rowCpData"
            :grid-options="cpGridOptions"
            @selectRowChange="selectRowChange"
          />
          <div ref="txtCpRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
            <textarea v-model="txtCpRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('Pricing.PendingPrice')" name="ppList">
          <air-data-grid
            :v-if="activeTabName === 'ppList'"
            config-module="223102"
            :show-create="true"
            :show-modify="true"
            :show-selection="true"
            :show-agent="false"
            :row-data="rowPpData"
            :grid-options="ppGridOptions"
            @selectRowChange="selectRowChange"
          />
          <div ref="txtPpRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
            <textarea v-model="txtPpRemarks" no="txtPpRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
          </div>
        </el-tab-pane>
      </el-tabs>
      <div style="position: absolute; left: 160px;margin: 10px;">
        <span>{{ globalMsg }}</span>
      </div>
    </div>
    <air-form
      v-if="airFormDialog.visible"
      :visible="airFormDialog.visible"
      :price-air="airFormDialog.priceAir"
      :is-new="airFormDialog.isNew"
      :is-cp="isActiveCpTab"
      :level="filter.level"
      @close="onAirFormDialogClose"
      @reload="toQuery"
    />
    <air-markup-popup
      v-if="airMarkupDialog.visible"
      ref="airMarkupPopup"
      :visible="airMarkupDialog.visible"
      :config-util="configUtil"
      :keys="airMarkupDialog.keys"
      :selected-rows="airMarkupDialog.selectedRows"
      @close="airMarkupDialog.visible = false"
      @approveSuccess="onApproveSuccess"
    />
    <air-settings-popup
      v-if="airSettingsPopupDialog.visible"
      ref="airSettingsPopup"
      :visible="airSettingsPopupDialog.visible"
      :config-util="configUtil"
      :is-h-q-manager="isHQManager"
      @close="airSettingsPopupDialog.visible = false"
    />
    <air-settings-dialog
      ref="settingsDialog"
      :visible="airSettingsDialog.visible"
      @close="airSettingsDialog.visible = false"
    />
    <air-markup-scheme-dialog
      ref="schemeDialog"
      :visible="airMarkupSchemeDialog.visible"
      :selected-rows="airMarkupSchemeDialog.selectedRows"
      @close="onAirMarkupSchemeDialogClose"
      @auditBack="auditBack"
    />
  </div>
</template>

<script>
import AirSearchBar from '@/views/cargo/v0/Price/components/query/airSearchBar'
import URL from '@/api/urlTranslator'
import DateUtils from '@/utils/dateUtils'
import AirDataGrid from '@/views/cargo/v0/Price/components/grid/airDataGrid'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import StrUtils from '@/utils/StrUtils'
import AirForm from '@/views/cargo/v0/Price/PriceAir/components/airForm'
import AirMarkupPopup from '@/views/cargo/v0/Price/PriceAir/components/airMarkupPopup'
import AirSettingsPopup from '@/views/cargo/v0/Price/PriceAir/components/airSettingsPopup'
import AirSettingsDialog from '@/views/cargo/v0/Price/PriceAir/components/airSettingsDialog'
import AirMarkupSchemeDialog from '@/views/cargo/v0/Price/PriceAir/components/airMarkupSchemeDialog'
import { getLoading } from '@/utils/utilBaseElement'
import { queryPriceAirList, deletePriceAirs, markupApprovePriceAirs } from '@/api/price/priceAir'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { deepClone } from '@/utils'
import { PriceAirPrivilegeUtils } from '@/class/cargo/model/utils/PriceAirPrivilegeUtils'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import { PricingAirConfigUtil } from '@/class/cargo/model/utils/PricingAirConfigUtil'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { PriceUploadExceptionUtil } from '@/class/cargo/model/utils/PriceUploadExceptionUtil'
import LocalStorageUtils from '@/utils/localStorageUtils'
import checkPermission from '@/utils/permission'
export default {
  name: 'PriceAir',
  components: { AirSettingsPopup, AirMarkupPopup, AirForm, AirDataGrid, AirSearchBar, AirSettingsDialog, AirMarkupSchemeDialog },
  data() {
    return {
      URL,
      fullscreenLoading: null,
      globalMsg: '',
      configUtil: null,
      airUtil: null,
      isHQManager: false,
      activeTabName: 'cpList',
      approveAllowed_PP: false,
      deleteAllowed_PP: false,
      deleteAllowed_CP: false,
      inputAllowed_PP: false,
      cpSelectRow: null, // 已发布的单击选择行
      ppSelectRow: null, // 待审核的单击选择行
      rowCpData: [],
      rowPpData: [],
      priceFclUtil: null,
      selectedPpRows: null,
      txtCpRemarks: '',
      txtPpRemarks: '',
      remarkCpChange: false,
      remarkPpChange: false,
      cpGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: event => {
          this.selectedPpRows = event.api.getSelectedRows()
          const rows = this.selectedPpRows.length
          this.globalMsg = rows > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows) : ''
        }
      },
      ppGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: event => {
          this.selectedPpRows = event.api.getSelectedRows()
          const rows = this.selectedPpRows.length
          this.globalMsg = rows > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows) : ''
        }
      },
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        opOffice: 0,
        carrier: 0,
        pol: '',
        pod: '',
        cod: '',
        col: '',
        cmbCreatedBy: 'createdBy',
        level: '',
        currency: 'RMB',
        allIn: false,
        beginDate: DateUtils.formatStandardDate(new Date()),
        endDate: '',
        simPol: 0,
        simPod: 0,
        createdBy: 0
      },
      airFormDialog: {
        visible: false,
        priceAir: {},
        isNew: false
      },
      airMarkupDialog: {
        visible: false,
        selectedRows: [],
        keys: []
      },
      airSettingsPopupDialog: {
        visible: false
      },
      airSettingsDialog: {
        visible: false
      },
      airMarkupSchemeDialog: {
        visible: false,
        selectedRows: []
      }
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    },
    isActiveCpTab() {
      return this.activeTabName === 'cpList'
    },
    branchId() {
      return this.$store.getters.currentOfficeId
    }
  },
  watch: {
    activeTabName(val) {
      LocalStorageUtils.setConfiguration('PriceAir', val)
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      const activeTab = LocalStorageUtils.getConfiguration('PriceAir')
      this.activeTabName = !StrUtils.isEmpty(activeTab) ? activeTab : 'ppList'
      this.airUtil = await PriceAirPrivilegeUtils.getInstance()
      this.configUtil = await PricingAirConfigUtil.getInstance()
      this.isHQManager = MultiCompanyUtil.getInstance().isHQManager('PriceAir')
      if (this.$store.getters.isAdmin) {
        this.approveAllowed_PP = true
        this.deleteAllowed_PP = true
        this.deleteAllowed_CP = true
        this.inputAllowed_PP = true
      } else {
        this.approveAllowed_PP = this.deleteAllowed_CP = this.airUtil.isApprove
        this.inputAllowed_PP = this.airUtil.isInput
      }
    },
    // tab 页签点击事件
    handleTabClick(tab, event) {
      console.log(tab, event)
      if (tab.name === this.activeTabName && this.$refs[this.activeTabName]) {
        this.$refs[this.activeTabName].fetchOrderRequirement()
      }
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.toQuery()
    },
    // 查询
    toSimpleQuery(proxy) {
      this.proxy = proxy
      this.toQuery()
    },
    toQuery() {
      this.fullscreenLoading = getLoading()
      this.proxy.state = this.isActiveCpTab ? PriceConstant.PRICE_STATE_EFFECTIVE : PriceConstant.PRICE_STATE_PENDING
      queryPriceAirList(this.proxy).then((res) =>
        this.handleQueryData(res)
      ).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    getGridOptionsApi() {
      return this.isActiveCpTab ? this.cpGridOptions.api : this.ppGridOptions.api
    },
    loadingEnd() {
      const api = this.getGridOptionsApi()
      api.clearFocusedCell()
      if (this.isActiveCpTab) {
        this.txtCpRemarks = ''
      } else {
        this.txtPpRemarks = ''
      }
      this.selectRowChange(null)
      this.fullscreenLoading.close()
    },
    handleQueryData(res) {
      const _resMap = res.data
      this.loadingEnd()
      if (!_resMap || _resMap.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.setRowData([])
        return
      }
      const count = _resMap.length
      // 只返回部分结果的话，弹窗提醒是否加载更多
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
        this.$confirm(msg, this.$t('Pricing.Tips'), {
          confirmButtonText: this.$t('Pricing.YesLabel'),
          cancelButtonText: this.$t('Pricing.NoLabel'),
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
        }).catch(() => {
          this.proxy.isLimited = false
          this.toAdvancedQuery(this.proxy)
          return
        })
      }
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        _resMap.pop()
      }
      this.setRowData(_resMap)
    },
    setRowData(result, reset = false) {
      if (this.isActiveCpTab) {
        this.rowCpData = result
        this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowCpData.length)
      } else {
        this.rowPpData = result
        this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowPpData.length)
      }
      if (reset) {
        this.globalMsg = ''
      }
    },
    onRowDoubleClicked(e) {
      const data = e.data
      if (this.isActiveCpTab) {
        this.cpSelectRow = data
      } else {
        this.ppSelectRow = data
      }
      this.onEdit()
    },
    onEdit() {
      const data = this.isActiveCpTab ? this.cpSelectRow : this.ppSelectRow
      if (!data) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      this.airFormDialog.visible = true
      this.airFormDialog.isNew = false
      if (this.isActiveCpTab) {
        delete data.uuid
      }
      this.airFormDialog.priceAir = deepClone(data)
    },
    selectRowChange(data) {
      if (this.isActiveCpTab) {
        this.cpSelectRow = data
      } else {
        this.ppSelectRow = data
      }
    },
    gridRefresh() {
    },
    resetGrid() {
      this.setRowData([], true)
      this.selectRowChange(null)
    },
    onTxtRemarksDoubleClick() {
      this.$nextTick(() => {
        const remark = (this.isActiveCpTab) ? 'txtCpRemark' : 'txtPpRemark'
        const remarkChange = (this.isActiveCpTab) ? this.remarkCpChange : this.remarkPpChange
        this.$refs[remark].style.height = !remarkChange ? '30%' : '6%'
        if (this.isActiveCpTab) {
          this.remarkCpChange = !this.remarkCpChange
        } else {
          this.remarkPpChange = !this.remarkPpChange
        }
      })
    },
    onGridRowClickedEvent(e) {
      const data = e.data
      this.selectRowChange(data)
      if (this.isActiveCpTab) {
        this.txtCpRemarks = data.remarks
      } else {
        this.txtPpRemarks = data.remarks
      }
    },
    onAirFormDialogClose() {
      this.airFormDialog.visible = false
      this.airFormDialog.priceAir = {}
    },
    onAdd_PP() {
      this.airFormDialog.visible = true
      this.airFormDialog.isNew = true
      this.airFormDialog.priceAir = {
        state: PriceConstant.PRICE_STATE_PENDING,
        level: 0,
        currency: 'USD',
        weightVolume: 0,
        aircraft: '',
        secondAircraft: '',
        t1Min: PriceConstant.NIL,
        t1Step: PriceConstant.NIL,
        t1P45: PriceConstant.NIL,
        t1P100: PriceConstant.NIL,
        t1P300: PriceConstant.NIL,
        t1P500: PriceConstant.NIL,
        t1P1000: PriceConstant.NIL,
        t2Min: PriceConstant.NIL,
        t2Step: PriceConstant.NIL,
        t2P45: PriceConstant.NIL,
        t2P100: PriceConstant.NIL,
        t2P300: PriceConstant.NIL,
        t2P500: PriceConstant.NIL,
        t2P1000: PriceConstant.NIL,
        t3Min: PriceConstant.NIL,
        t3Step: PriceConstant.NIL,
        t3P45: PriceConstant.NIL,
        t3P100: PriceConstant.NIL,
        t3P300: PriceConstant.NIL,
        t3P500: PriceConstant.NIL,
        t3P1000: PriceConstant.NIL
      }
    },
    onDelete_PP() {
      const selectedRows = this.getSelectedRows()
      if (!selectedRows) return
      for (const item of selectedRows) {
        if (!(this.deleteAllowed_PP || item.createdBy === this.$store.getters.userInfo.userId)) {
          this.$message.warning(this.$t('Pricing.NotAllowedDelete'))
          return null
        }
      }
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('Pricing.IsDeleteRecords'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.toDel(selectedRows, uuids)
      })
    },
    toDel(selectRows, uuids) {
      this.fullscreenLoading = getLoading()
      deletePriceAirs(uuids).then(res => {
        this.$message.success(this.$t('Pricing.HasDeleted'))
        this.loadingEnd()
        const api = this.getGridOptionsApi()
        api.updateRowData({ remove: selectRows })
      })
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    // 获取待审核的勾选数据
    getSelectedRows() {
      const api = this.getGridOptionsApi()
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    onDelete_CP() {
      const selectedRows = this.getSelectedRowsCp()
      if (!selectedRows) {
        return
      }
      this.$confirm(this.$t('Pricing.InvalidSelection'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.toDel(selectedRows, uuids)
      })
    },
    // 获取已发布的勾选数据
    getSelectedRowsCp() {
      const selectedRows = this.getSelectedRows()
      if (!this.isHQManager) {
        for (const item of selectedRows) {
          if (item.branchId !== this.$store.getters.currentOfficeId) {
            this.$message.warning(this.$t('Pricing.IsAllowedOperate_DiffBranch'))
            return null
          }
        }
      }
      return selectedRows
    },
    onApprove_PP() {
      if (this.onApproveChecked()) {
        this.$confirm(this.$t('Pricing.IsApproveRecord'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          if (parseInt(this.filter.level) === 0 && this.configUtil.needMarkup) {
            const selectedRows = this.getSelectedRows()
            const keys = this.getSelectUuids(selectedRows)
            this.airMarkupDialog.visible = true
            this.airMarkupDialog.keys = keys
            this.airMarkupDialog.selectedRows = selectedRows
            this.$nextTick(() => {
              this.$refs['airMarkupPopup'].readConfig()
            })
          }
        })
      }
    },
    // 加价审核
    onMarkupApprove() {
      if (this.onApproveChecked()) {
        this.$confirm(this.$t('Pricing.IsApproveRecord'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          const selectedRows = this.getSelectedRows()
          const keys = this.getSelectUuids(selectedRows)
          this.fullscreenLoading = getLoading()
          markupApprovePriceAirs(keys).then(res => {
            this.onApproveSuccess(selectedRows)
            this.loadingEnd()
          }).catch(e => {
            this.loadingEnd()
          })
        })
      }
    },
    // 审核前校验
    onApproveChecked() {
      const selectedRows = this.getSelectedRows()
      if (!this.$store.getters.isAdmin) {
        const officeIds = MultiCompanyUtil.getInstance().getOfficeIDsForApprove('PriceAir')
        if (!officeIds || officeIds === null || officeIds.length === 0) {
          return false
        }
        if (officeIds[0] === 0) {
          const ofcIDMap = {}
          for (let i = officeIds.length - 1; i >= 1; i--) {
            ofcIDMap[officeIds[i]] = i // ofcIDs中可能存在重复的id，但不影响
          }
          for (const item of selectedRows) {
            if (!ofcIDMap.hasOwnProperty(item.branchId)) {
              this.$confirm(StrUtils.substitute(this.$t('Pricing.IsAllowedOperate'), item.pol, item.pod), this.$t('Message.Prompt'), {
                confirmButtonText: this.$t('common.btn.ok'),
                cancelButtonText: this.$t('common.btn.cancel'),
                type: 'warning'
              }).then(() => {
                // 定位到该列
              })
              return false
            }
          }
        }
      }
      return true
    },
    onConfigPriceAir() {
      this.airSettingsPopupDialog.visible = true
      this.$nextTick(() => {
        this.$refs['airSettingsPopup'].init()
      })
    },
    // 方案设置按钮
    schemeSettings() {
      this.airSettingsDialog.visible = true
      this.$nextTick(() => {
        this.$refs['settingsDialog'].init(this.configUtil)
      })
    },
    onApproveSuccess(selectedRows) {
      this.loadingEnd()
      const api = this.getGridOptionsApi()
      api.updateRowData({ remove: selectedRows })
    },
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('Air_sample.xls', 'price')
    },
    uploadExcelSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(JSON.parse(response.data))
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message.success) {
        const result = message.resultMessage
        const records = result.split(',')
        let msg = ''
        if (records.length > 1) {
          for (const sheet of records) {
            if (StrUtils.isEmpty(sheet)) {
              continue
            }
            const tmp = sheet.split(':')
            msg += StrUtils.substitute(this.$t('Pricing.Records'), tmp) + '\n'
          }
          msg += this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        } else {
          if (result === '') {
            this.$message.error(this.$t('Pricing.NoRecordUpload'))
          } else {
            const tmp = result.split(':')
            msg = StrUtils.substitute(this.$t('Pricing.Records'), tmp)
            msg = msg.substr(0, msg.length - 1) + this.$t('Pricing.LoadSucceed')
            this.$message.success(msg)
          }
        }
        return
      }
      // 导入失败
      const failResult = PriceUploadExceptionUtil.handleError(message)
      const msg = {
        dangerouslyUseHTMLString: true,
        message: failResult.replace(/\n\t/g, '<br/>'),
        type: 'error',
        duration: 5000
      }
      this.$message.error(msg)
    },
    checkPermission() {
      return checkPermission(['PAA'])
    },
    // 方案加价审核
    onApprove_PP2() {
      const selectedRows = this.getSelectedRowsPp()
      if (selectedRows === null) return
      if (!this.isAllowedApprove(selectedRows)) return
      this.airMarkupSchemeDialog.visible = true
      this.airMarkupSchemeDialog.selectedRows = selectedRows
      this.$nextTick(() => {
        this.$refs['schemeDialog'].init(this.configUtil)
      })
    },
    // 获取待审核的勾选数据
    getSelectedRowsPp() {
      const { api } = this.ppGridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    isAllowedApprove(selectedRows) {
      if (!this.$store.getters.isAdmin) {
        const officeIds = MultiCompanyUtil.getInstance().getOfficeIDsForApprove('PriceAir')
        if (!officeIds || officeIds === null || officeIds.length === 0) {
          return false
        }
        if (officeIds[0] === 0) {
          const ofcIDMap = {}
          for (let i = officeIds.length - 1; i >= 1; i--) {
            ofcIDMap[officeIds[i]] = i // ofcIDs中可能存在重复的id，但不影响
          }
          for (const item of selectedRows) {
            if (!ofcIDMap.hasOwnProperty(item.branchId)) {
              this.$confirm(StrUtils.substitute(this.$t('Pricing.IsAllowedOperate'), item.pol, item.pod), this.$t('Message.Prompt'), {
                confirmButtonText: this.$t('common.btn.ok'),
                cancelButtonText: this.$t('common.btn.cancel'),
                type: 'warning'
              }).then(() => {
                // 定位到该列
              })
              return false
            }
          }
        }
      }
      return true
    },
    onAirMarkupSchemeDialogClose() {
      this.airMarkupSchemeDialog.visible = false
      this.airMarkupSchemeDialog.rowData = {}
    },
    auditBack() {
      const { api } = this.ppGridOptions
      const selectedRows = api.getSelectedRows()
      this.removeData(selectedRows)
    },
    removeData(selectedRows) {
      if (selectedRows) {
        let api = null
        if (this.isCp) {
          this.cpSelectRow = null
          api = this.cpGridOptions.api
        } else {
          this.selectedPpCount = 0
          this.ppSelectRow = null
          api = this.ppGridOptions.api
        }
        api.updateRowData({ 'remove': selectedRows })
      }
    }
  }
}
</script>

<style scoped>

</style>
